import {
    LIST_ROOMS,
    LIST_ROOMS_SUCCESS,
    LIST_ROOMS_ERROR,
    ADD_ROOMS,
    SAVE_ROOMS,
    SAVE_ROOMS_SUCCESS,
    SAVE_ROOMS_ERROR,
    DELETE_ROOMS,
    DELETE_ROOMS_SUCCESS,
    DELETE_ROOMS_ERROR,
    EDIT_ROOMS,
    UPDATE_ROOMS,
    UPDATE_ROOMS_SUCCESS,
    UPDATE_ROOMS_ERROR
} from '../types';

import clienteAxios from '../config/axios';
import authToken from '../config/token';

import roomsData from '../data/rooms';
import { ErrorMessage, SuccessMessage, WaitingMessage } from '../components/extras/toastMessages';
import { MSG_CREATE_SUCCESS, MSG_UPDATE_SUCCESS, MSG_DELETING, MSG_DELETE_SUCCESS } from '../constants/messages';
import Swal from 'sweetalert2';
import { METHOD_DISABLED } from '../constants/requestMethods';

const controller = 'sala';

//LISTAR AUDIENCE MOTIVES
export function listRoomsAction(params) {
    return async (dispatch) => {
        //Inicializo
        dispatch( listRooms() );
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            const response = await clienteAxios.get(`/${controller}`, { params });
            //Obtengo los datos
            const rooms = response.data;
            //const rooms = roomsData;
            //Llamo al dispatch
            dispatch( listRoomsSuccess(rooms.content) );
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( listRoomsError(data) );
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const listRooms = () => ({
    type: LIST_ROOMS,
    payload: true
});

const listRoomsSuccess = rooms => ({
    type: LIST_ROOMS_SUCCESS,
    payload: rooms
});

const listRoomsError = error => ({
    type: LIST_ROOMS_ERROR,
    payload: error
});

//ADD AUDIENCE MOTIVE
export function addRoomsAction(showForm) {
    return (dispatch) => {
        //Inicializo
        dispatch( addRooms(false) );
        //Abro el formulario
        showForm();
    }
}

const addRooms = isEdit => ({
    type: ADD_ROOMS,
    payload: isEdit
});

//SAVE AUDIENCE MOTIVE
export function saveRoomsAction(room, handleClose) {
    return async (dispatch) => {
        //Inicializo
        dispatch( saveRooms() );
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            const response = await clienteAxios.post(`/${controller}`, room);
            //Obtengo los datos
            //const res = response.data;
            //Llamo al dispatch
            dispatch( saveRoomsSuccess(response.data) );
            //Cierro la ventana
            handleClose();
            //Mensaje
            SuccessMessage(MSG_CREATE_SUCCESS);
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( saveRoomsError(data) );
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const saveRooms = () => ({
    type: SAVE_ROOMS,
    payload: true
});


const saveRoomsSuccess = room => ({
    type: SAVE_ROOMS_SUCCESS,
    payload: room
});

const saveRoomsError = error => ({
    type: SAVE_ROOMS_ERROR,
    payload: error
});

//EDIT AUDIENCE MOTIVE
export function editRoomsAction(room, showForm) {
    return async (dispatch) => {
        //Inicializo
        dispatch( editRooms(room) );
        //Abro el formulario
        showForm();
    }
}

const editRooms = room => ({
    type: EDIT_ROOMS,
    payload: room
});

//UPDATE AUDIENCE MOTIVE
export function updateRoomsAction(room, handleClose) {
    return async (dispatch) => {
        //Inicializo
        dispatch( updateRooms() );
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            const response = await clienteAxios.put(`/${controller}/${room.id}`, room);
            //Obtengo los datos
            //const res = response.data;
            //Llamo al dispatch
            dispatch( updateRoomsSuccess(response.data) );
            //Cierro la ventana
            handleClose();
            //Mensaje
            SuccessMessage(MSG_UPDATE_SUCCESS);
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( updateRoomsError(data) );
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const updateRooms = () => ({
    type: UPDATE_ROOMS,
    payload: true
});

const updateRoomsSuccess = room => ({
    type: UPDATE_ROOMS_SUCCESS,
    payload: room
});

const updateRoomsError = error => ({
    type: UPDATE_ROOMS_ERROR,
    payload: error
});

//DELETE AUDIENCE MOTIVE
export function deleteRoomsAction(room) {
    return async (dispatch) => {
        //Inicializo
        dispatch( deleteRooms() );
        //Mensaje de Espera
        WaitingMessage(MSG_DELETING);
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            // const response = await clienteAxios.delete(`/${controller}/${room.id}`);
            const response = await clienteAxios.put(`/${controller}/${room.id}/${METHOD_DISABLED}`);
            //Obtengo los datos
            //const res = response.data;
            //Llamo al dispatch
            dispatch( deleteRoomsSuccess(response.data) );
            //Oculto espera
            Swal.close();
            //Mensaje
            SuccessMessage(MSG_DELETE_SUCCESS);
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( deleteRoomsError(data) );
            //Oculto espera
            Swal.close();
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const deleteRooms = () => ({
    type: DELETE_ROOMS,
    payload: true
});

const deleteRoomsSuccess = room => ({
    type: DELETE_ROOMS_SUCCESS,
    payload: room
});

const deleteRoomsError = error => ({
    type: DELETE_ROOMS_ERROR,
    payload: error
});